import React from 'react';
import {ReactComponent as CopyLinkSvg} from 'resources/icons/copy_link.svg';

export const CopyLinkIcon = () => {
  return <CopyLinkSvg />;
};
